import { Link } from 'react-router-dom';
import { Square } from 'lucide-react';

const ScrollLink = ({ to, children, className }) => (
  <Link to={to} className={className} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
    {children}
  </Link>
);

export function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800/50">
      {/* Subtle gradient line at top */}
      <div className="h-px bg-gradient-to-r from-transparent via-orange-500/20 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
                <Square className="w-4 h-4 text-white" />
              </div>
              <span className="text-white font-heading font-bold text-lg tracking-tight">SquareCount</span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed max-w-xs">
              Professional satellite roof measurements at 90% less cost than traditional services.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-medium text-slate-400 text-sm mb-4">Product</h4>
            <ul className="space-y-2.5 text-slate-500 text-sm">
              <li><ScrollLink to="/pricing" className="hover:text-slate-300 transition-colors duration-200">Pricing</ScrollLink></li>
              <li><ScrollLink to="/features" className="hover:text-slate-300 transition-colors duration-200">Features</ScrollLink></li>
              <li><ScrollLink to="/eagleview-alternative" className="hover:text-slate-300 transition-colors duration-200">EagleView Alternative</ScrollLink></li>
              <li><ScrollLink to="/roofr-alternative" className="hover:text-slate-300 transition-colors duration-200">Roofr Alternative</ScrollLink></li>
              <li><ScrollLink to="/hover-alternative" className="hover:text-slate-300 transition-colors duration-200">Hover Alternative</ScrollLink></li>
              <li><ScrollLink to="/quickmeasure-alternative" className="hover:text-slate-300 transition-colors duration-200">QuickMeasure Alternative</ScrollLink></li>
              <li><ScrollLink to="/eagleview-pricing" className="hover:text-slate-300 transition-colors duration-200">EagleView Pricing</ScrollLink></li>
              <li><ScrollLink to="/drone-vs-satellite-roof-measurement" className="hover:text-slate-300 transition-colors duration-200">Drone vs Satellite</ScrollLink></li>
              <li><ScrollLink to="/gutter-measurement" className="hover:text-slate-300 transition-colors duration-200">Gutter Measurement</ScrollLink></li>
              <li><ScrollLink to="/google-earth-roof-measurement-alternative" className="hover:text-slate-300 transition-colors duration-200">vs Google Earth</ScrollLink></li>
              <li><ScrollLink to="/roof-measurement-software" className="hover:text-slate-300 transition-colors duration-200">Roof Measurement Software</ScrollLink></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-medium text-slate-400 text-sm mb-4">Company</h4>
            <ul className="space-y-2.5 text-slate-500 text-sm">
              <li><ScrollLink to="/about" className="hover:text-slate-300 transition-colors duration-200">About</ScrollLink></li>
              <li><ScrollLink to="/contact" className="hover:text-slate-300 transition-colors duration-200">Contact</ScrollLink></li>
              <li><ScrollLink to="/blog" className="hover:text-slate-300 transition-colors duration-200">Blog</ScrollLink></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-medium text-slate-400 text-sm mb-4">Resources</h4>
            <ul className="space-y-2.5 text-slate-500 text-sm">
              <li><ScrollLink to="/free-alternative" className="hover:text-slate-300 transition-colors duration-200">Free Roof Software</ScrollLink></li>
              <li><ScrollLink to="/tools/pitch-calculator" className="hover:text-slate-300 transition-colors duration-200">Roof Pitch Calculator</ScrollLink></li>
              <li><ScrollLink to="/tools/gutter-calculator" className="hover:text-slate-300 transition-colors duration-200">Gutter Calculator</ScrollLink></li>
              <li><ScrollLink to="/tools/roof-squares-calculator" className="hover:text-slate-300 transition-colors duration-200">Roofing Squares Calculator</ScrollLink></li>
              <li><ScrollLink to="/privacy" className="hover:text-slate-300 transition-colors duration-200">Privacy Policy</ScrollLink></li>
              <li><ScrollLink to="/terms" className="hover:text-slate-300 transition-colors duration-200">Terms of Service</ScrollLink></li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-medium text-slate-400 text-sm mb-4">Service Areas</h4>
            <ul className="space-y-2.5 text-slate-500 text-sm">
              <li><ScrollLink to="/locations/houston-tx" className="hover:text-slate-300 transition-colors duration-200">Houston, TX</ScrollLink></li>
              <li><ScrollLink to="/locations/jacksonville-fl" className="hover:text-slate-300 transition-colors duration-200">Jacksonville, FL</ScrollLink></li>
              <li><ScrollLink to="/locations/portland-or" className="hover:text-slate-300 transition-colors duration-200">Portland, OR</ScrollLink></li>
              <li><ScrollLink to="/locations/nashville-tn" className="hover:text-slate-300 transition-colors duration-200">Nashville, TN</ScrollLink></li>
              <li><ScrollLink to="/locations/charlotte-nc" className="hover:text-slate-300 transition-colors duration-200">Charlotte, NC</ScrollLink></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800/60 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 text-sm">
            &copy; {new Date().getFullYear()} SquareCount.io. All rights reserved.
          </p>
          <p className="text-slate-600 text-sm">
            Built for roofing contractors.
          </p>
        </div>
      </div>
    </footer>
  );
}
